<template>
  <el-form
    :model="form"
    :rules="rules"
  >
    <el-form-item
      :label="$t('general.oldPassword')"
      prop="oldPassword"
      label-position="top"
    >
      <el-input
        v-model="form.oldPassword"
        type="password"
      />
    </el-form-item>
    <el-form-item
      :label="$t('general.newPassword')"
      prop="newPassword"
      label-position="top"
    >
      <el-input
        v-model="form.newPassword"
        type="password"
      />
    </el-form-item>
    <el-form-item
      :label="$t('general.confirmNewPassword')"
      prop="confirmNewPassword"
      label-position="top"
    >
      <el-input
        v-model="form.confirmNewPassword"
        type="password"
      />
    </el-form-item>
    <button
      class="el-button"
      @click="handleSubmit"
    >
      {{ $t('Submit') }}
    </button>
  </el-form>
</template>
<script>
import { Message } from 'element-ui'
import { changePassword } from '@/api/auth'
export default {
  name: 'VrLoungeEditPassword',
  data () {
    const validateNewPassword = (rule, value, callback) => {
      callback(new Error(this.$t('vrlounge.passwordRule')))
    }
    const validateConfirmNewPassword = (rule, value, callback) => {
      if (this.form.newPassword === this.form.confirmNewPassword) callback()
      else callback(new Error(this.$t('general.unmatched', { col: this.$t('general.password') })))
    }

    return {
      form: {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: ''
      },
      rules: {
        oldPassword: [{ required: true, message: this.$t('general.required') }],
        newPassword: [{ validator: validateNewPassword }, { required: true, message: this.$t('general.required') }],
        confirmNewPassword: [{ validator: validateConfirmNewPassword }, { required: true, message: this.$t('general.required') }]
      }
    }
  },
  methods: {
    async handleSubmit (e) {
      e.preventDefault()
      const payload = {
        username: 'email',
        oldPassword: this.form.oldPassword,
        newPassword: this.form.newPassword
      }
      await changePassword(payload)
        .then(() => Message.success(this.$t('general.updateSuccess')))
        .then(() => this.$emit('to-profile'))
        .catch((reason) => Message({ message: reason, type: 'error' }))
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~css/addon/main'

.el-form {
  max-width: 100%
  width: 300px
  margin: 0 auto
  @media (max-width: $response-xs) {
    padding: 0
    height: calc(100vh - 60px)
  }
}

.el-button {
  margin-top: 20px
  background-color: $pink-color
  width: 100%
  font-size: 20px
  color: $white
  border: none
}
</style>
